import type { TradeOfferValues, Validators } from './types'
import { isValidUrl } from 'utils/validators'
import { websiteMask } from '../../utils/masks'

//  Ошибка означающая, что пара [Product URL, Additional ID] существует
export const ERROR_WRONG_COUPLE_ADD_ID_PRODUCT_URL = 'wrongCoupleAdIdUrl'
//  Ошибка означающая, что Product URL существует и уникален
export const ERROR_PRODUCT_URL_USED_UNIQUE = 'usedUnique'

const wine = () => {
  return null
}

const productURL = (values: TradeOfferValues) => {
  if (!values.productURL) return 'error.fieldRequired'
  if (!isValidUrl(values.productURL) || !websiteMask.test(values.productURL))
    return 'error.websiteExample'

  const isIDEqual = values?.id !== values?.tradeOfferIdByProductUrl
  const isUnqueUsed = values.isProductURLUsed
  if ((values?.id && isIDEqual && isUnqueUsed) || (!values?.id && isUnqueUsed))
    return ERROR_PRODUCT_URL_USED_UNIQUE
  return null
}

// const merchant = (values: TradeOfferValues) => {
//   if (!values.merchant?.id) return 'error.fieldRequired'
//   return null
// }

const validators: Validators = {
  wine,
  productURL,
}

export default validators
